<template>
  <card-item card="item_discipline" :tabs="tabs" :activeTab="activeTab" :id="id" :infoKeys="infoKeys"/>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация", key:'information_card',
          component: () => import("./Info"),
        },
        {
                    key:'lessonplans_card',
          title: "Плановые уроки",
          component: () => import("./DisciplineLessonplan"),
        },
      ],
      activeTab: 0,
             infoKeys:[
        {
          key: 'title',
          title:'Предмет'
        },
      
        ]
    };
  },
};
</script>